/**
 * @group Constants
 * @summary
 * <blockquote>Configuration constants for scanner video capture and frame streaming</blockquote>
 * 
 * @example
 * ```typescript
 * const fps = SCANNER_CAPTURE_CONSTANTS.DEFAULT_TARGET_FPS;
 * ```
 */
// 1024 is a standard mathematical constant (2^10, bytes per kilobyte) - no need for shared constant
// eslint-disable-next-line @template/constants-usage
const BYTES_PER_KB = 1024;
const WS_BUFFERED_LIMIT_KB = 512;

export const SCANNER_CAPTURE_CONSTANTS = {
  DEFAULT_TARGET_FPS: 15,
  MIN_TARGET_FPS: 1,
  MAX_TARGET_FPS: 30,
  CAPTURE_MAX_LONG_SIDE: 640,
  WS_BUFFERED_LIMIT_BYTES: WS_BUFFERED_LIMIT_KB * BYTES_PER_KB, // 512 KB
} as const;
